if (!customElements.get('collection-filters-form')) {
  class CollectionFiltersForm extends HTMLElement {
    connectedCallback () {
      this.els = {
        form: {
          selector: '[data-collection-filters-form-el="form"]',
          element: this.querySelector(`[data-collection-filters-form-el="form"]`),
        },
        count: {
          selector: '[data-collection-filters-form-el="count"]',
          elements: this.querySelectorAll(`[data-collection-filters-form-el="count"]`),
        },
        facet: {
          selector: '[data-collection-filters-form-el="facet"]',
          elements: this.querySelectorAll(`[data-collection-filters-form-el="facet"]`),
        },
        modalElement: {
          selector: '[data-collection-filters-form-el="modalElement"]',
          elements: this.querySelectorAll(`[data-collection-filters-form-el="modalElement"]`),
        },
        modalClose: {
          selector: '[data-collection-filters-form-el="modalClose"]',
          elements: this.querySelectorAll(`[data-collection-filters-form-el="modalClose"]`),
        },
        showMore: {
          selector: '[data-collection-filters-form-el="showMore"]',
          elements: this.querySelectorAll(`[data-collection-filters-form-el="showMore"]`),
        },
        removeFilterList: {
          selector: '[data-collection-filters-form-el="removeFilterList"]',
          element: this.querySelector(`[data-collection-filters-form-el="removeFilterList"]`),
        },
        removeFilter: {
          selector: '[data-collection-filters-form-el="removeFilter"]',
          elements: this.querySelectorAll(`[data-collection-filters-form-el="removeFilter"]`),
        },
        clearAll: {
          selector: '[data-collection-filters-form-el="clear"]',
          elements: this.querySelector('[data-collection-filters-form-el="clear"]'),
        },
        drawerToggle: {
          selector: '[data-collection-filters-form-el="drawerToggle"]',
          element: this.querySelector('[data-collection-filters-form-el="drawerToggle"]'),
        },
      }

      this.externalEls = {
        productGrid: {
          selector: '.vbf-product-grid',
          element: document.querySelector('.vbf-product-grid'),
        },
        productGridContainer: {
          selector: '[data-collection-filters-form-external-el="productGridContainer"]',
          element: document.querySelector(`[data-collection-filters-form-external-el="productGridContainer"]`),
        },
        collectionFilterContainer: {
          selector: '[data-collection-filters-form-external-el="collectionFilterContainer"]',
          element: document.querySelector(`[data-collection-filters-form-external-el="collectionFilterContainer"]`),
        },
      }

      this.filterData = []
      this.searchParamsInitial = window.location.search.slice(1)
      this.searchParamsPrev = window.location.search.slice(1)

      this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
      this.setupListeners()
    }

    setupListeners () {
      this.debouncedOnSubmit = window.debounce(event => {
        this.onSubmitHandler(event)
      }, 300)

      this.els.form.element.addEventListener(
        'change',
        this.debouncedOnSubmit.bind(this),
      )

      const onHistoryChange = event => {
        const searchParams = event.state
          ? event.state.searchParams
          : this.searchParamsInitial
        if (searchParams === this.searchParamsPrev) return
        this.renderPage(searchParams, null, false)
      }

      this.els.facet.elements.forEach(el => {
        el.addEventListener('click', this.onFacetClick.bind(this))
      })

      window.addEventListener('popstate', onHistoryChange)

      document.addEventListener('click', event => {
        if (
          !event.target.closest(this.els.facet.selector) &&
          window.innerWidth > 768
        ) {
          this.els.facet.elements.forEach(el => {
            el.removeAttribute('open')
          })
        }
      })

      this.els.facet.elements.forEach(el => {
        el.addEventListener('click', this.onAccordionToggle.bind(this))
      })

      this.els.modalClose.elements.forEach(el => {
        el.addEventListener('click', this.onModalCloseClick.bind(this))
      })

      this.els.clearAll.elements.addEventListener('click', this.onClearAllClick.bind(this))

      this.addEventListener('click', event => {
        if (event.target.matches(this.els.showMore.selector)) {
          this.onShowMoreClick(event)
        }
      })

      this.addEventListener('click', event => {
        if (event.target.matches(this.els.removeFilter.selector)) {
          this.onRemoveFilterClick(event)
        }
      })

      this.els.drawerToggle.element.addEventListener('click', this.toggleFilterDrawer.bind(this))
    }

    onFacetClick (event) {
      const combobox = event.currentTarget.querySelector('[role="combobox"]')

      this.querySelectorAll('[role="combobox"]').forEach(el => {
        if (el !== combobox) {
          el.setAttribute('aria-expanded', 'false')
        }
      })

      if (event.currentTarget.hasAttribute('open')) {
        combobox.setAttribute('aria-expanded', 'false')
      } else {
        combobox.setAttribute('aria-expanded', 'true')
      }
    }

    syncFilterStates (changedInput) {
      // Retrieve the identifier for the changed input
      const filterId = changedInput.getAttribute('data-filter-id')
      // Select all inputs with the same data-filter-id
      const allCorrespondingInputs = document.querySelectorAll(`[data-filter-id="${filterId}"]`)

      // Update all corresponding inputs to match the changed input's state
      allCorrespondingInputs.forEach(input => {
        if (input !== changedInput) { // Avoid self-updating
          input.checked = changedInput.checked
        }
      })
    }

    toggleFilterDrawer () {
      setTimeout(() => {
        if (this.els.drawerToggle.element.hasAttribute('open')) {
          this.externalEls.collectionFilterContainer.element.style.zIndex = 10
        } else {
          this.externalEls.collectionFilterContainer.element.style.zIndex = 9
        }
      }, 100)
    }

    renderPage (searchParams, event, updateURLHash = true) {
      const sections = this.getSections()

      this.externalEls.productGrid.element.setAttribute('aria-busy', 'true')

      this.searchParamsPrev = searchParams

      sections.forEach(section => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
        const filterDataUrl = element => element.url === url

        this.filterData.some(filterDataUrl)
          ? this.renderSectionFromCache(filterDataUrl, event)
          : this.renderSectionFromFetch(url, event)
      })

      this.renderClearAll(searchParams)

      if (updateURLHash) this.updateURLHash(searchParams)
    }

    renderSectionFromFetch (url, event) {
      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = responseText
          this.filterData = [
            ...this.filterData,
            { html, url },
          ]
          this.renderFilters(html, event)
          this.renderProductGridContainer(html)
          this.renderProductCount(html)
          this.renderRemoveFilterList(html)
        })
    }

    renderSectionFromCache (filterDataUrl, event) {
      const html = this.filterData.find(filterDataUrl).html
      this.renderFilters(html, event)
      this.renderProductGridContainer(html)
      this.renderProductCount(html)
      this.renderRemoveFilterList(html)
    }

    renderProductGridContainer (html) {
      this.externalEls.productGridContainer.element.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(this.externalEls.productGridContainer.selector).innerHTML

      this.externalEls.productGrid.element.setAttribute('aria-busy', 'false')

      if (window.theme && window.theme.wishlist) {
        window.theme.wishlist.initialise()
      }
    }

    renderProductCount (html) {
      this.els.count.elements.forEach(el => {
        const newText = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(this.els.count.selector).innerHTML

        el.innerHTML = newText
      })
    }

    renderClearAll (searchParams) {
      const paramsArr = searchParams.split('&')
      const currentFilters = paramsArr.filter(param => param.indexOf('sort_by') === -1)

      this.els.clearAll.elements.setAttribute('aria-hidden', currentFilters.length === 0)
    }

    renderFilters (html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
      const facetElementList = parsedHTML.querySelectorAll(this.els.facet.selector)
      const facetElements = document.querySelectorAll(this.els.facet.selector)

      facetElementList.forEach(facetElement => {
        const matchingFacetElement = Array.from(facetElements).find(facet => facet.dataset.id === facetElement.dataset.id)
        matchingFacetElement.innerHTML = facetElement.innerHTML
      })
    }

    renderRemoveFilterList (html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
      const removeFilterListElement = parsedHTML.querySelector(this.els.removeFilterList.selector)

      this.els.removeFilterList.element.innerHTML = removeFilterListElement.innerHTML
    }

    updateURLHash (searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
      )
    }

    getSections () {
      return [
        {
          section: document.getElementById('product-grid').dataset.id,
        },
      ]
    }

    onSubmitHandler (event) {
      event.preventDefault()
      this.syncFilterStates(event.target)
      const formData = new FormData(this.els.form.element)
      const searchParams = new URLSearchParams(formData).toString()
      this.renderPage(searchParams, event)
    }

    toggleActiveFacets (disable = true) {
      document.querySelectorAll('.js-facet-remove').forEach(element => {
        element.classList.toggle('disabled', disable)
      })
    }

    onClearAllClick (event) {
      event.preventDefault()
      this.renderPage('')

      this.els.clearAll.elements.setAttribute('aria-hidden', 'true')
    }

    onActiveFilterClick (event) {
      event.preventDefault()
      this.toggleActiveFacets()
      const url =
        event.currentTarget.href.indexOf('?') === -1
          ? ''
          : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1,
          )
      this.renderPage(url)
    }

    onAccordionToggle (event) {
      if (window.innerWidth <= 768) return

      const accordion = event.target.closest(this.els.facet.selector)

      this.els.facet.elements.forEach(el => {
        if (el !== accordion) {
          el.removeAttribute('open')
        }
      })
    }

    onModalCloseClick (event) {
      const accordion = event.target.closest(this.els.modalElement.selector).previousElementSibling

      accordion.removeAttribute('open')
      this.toggleFilterDrawer()
    }

    onShowMoreClick (event) {
      const clickedElement = event.target
      const parentItem = clickedElement.closest('.clc-ProductGridFacet_List')
      const productGridFacetItems = parentItem.querySelectorAll('.clc-ProductGridFacet_Item')

      productGridFacetItems.forEach((item, index) => {
        if (clickedElement.dataset?.state === 'more') {
          item.classList.remove('clc-ProductGridFacet_Item-hidden')
        } else if (clickedElement.dataset?.state === 'less' && index > 8) {
          item.classList.add('clc-ProductGridFacet_Item-hidden')
        }
      })

      if (clickedElement.dataset?.state === 'more') {
        clickedElement.dataset.state = 'less'
        clickedElement.textContent = clickedElement.dataset.textLess
      } else if (clickedElement.dataset?.state === 'less') {
        clickedElement.dataset.state = 'more'
        clickedElement.textContent = clickedElement.dataset.textMore
      }
    }

    onRemoveFilterClick (event) {
      const filterToRemove = event.target.getAttribute('data-name')
      const filterValueToRemove = event.target.getAttribute('data-value')

      if (!filterToRemove || !filterValueToRemove) return

      const matchingFilter = document.querySelector(`input[name="${filterToRemove}"][value="${filterValueToRemove}"]`)

      matchingFilter.closest('label').click()
    }
  }

  customElements.define('collection-filters-form', CollectionFiltersForm)
}
